import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Gauge } from '../../../CommonComponents/OPL/charts/Gauge/Gauge';
import { usePulseCheckTheme } from '../../hooks/usePulseCheckTheme';

interface Props {
  isPrint?: boolean;
  size: number;
  categoryName: string;
  fulfillment: number;
  CategoryIcon: React.FC;
}

export const CategoryGauge = ({
  isPrint,
  size,
  categoryName,
  fulfillment,
  CategoryIcon,
}: Props) => {
  const theme = usePulseCheckTheme();

  return (
    <Box display="flex" justifyContent="center">
      <Box width={size} height={size} position="relative">
        <Gauge
          data={{
            name: categoryName,
            value: fulfillment * 10,
            color: theme.colors.accentColor,
            backgroundColor: theme.colors.neutral['300'],
          }}
          customSettings={{
            plotOptions: {
              series: {
                animation: !isPrint,
              },
            },
          }}
        />

        <Box
          width={36}
          height={36}
          style={{
            color: isPrint ? theme.colors.primary['500'] : 'white',
            top: '50%',
            left: '50%',
            position: 'absolute',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <CategoryIcon />
        </Box>
      </Box>
    </Box>
  );
};
